import React, { useState, useEffect } from "react";
import NoContent from "../../../reusableComponents/NoContentComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { amApi } from "../../../../api/apiHelper";
import ExpDashboardIcons from "./ExpDashboardIcons";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { successAlert } from "../../../../function/alert";
import _ from "lodash";
import moment from "moment";
import AllIcon from "../../../../assets/images/Orders/ordersall.png";
import { Image, Row, Col, Table } from "react-bootstrap";
import Media from "react-media";
import { NavLink } from "react-router-dom";
import { RightSideCountTop } from "../../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import ExperienceBody from "./ExperienceBody";
import StatusFilter from "./Modals/StatusFilter";
import BasicPagination from "../../../Pagination/Pagination";
import SearchBar from "../../../reusableComponents/SearchBar";

const seatingNew = require("../../../../assets/images/seatingImages/specialexp.png");
const pendingNew = require("../../../../assets/images/seatingImages/pendingexp.png");
const historyNew = require("../../../../assets/images/seatingImages/curatedexp.png");
const histNew = require("../../../../assets/images/seatingImages/historyexp.png");

const ExperienceCuratedDashboard = () => {
  const [expRequests, setExpRequests] = useState(null);
  const history = useHistory();
  const [isActive, setActive] = useState(false);
  const [search, setSearch] = useState("");
  const [paxFilter, setPaxFilter] = useState('null');
  const [groupByData, setGroupByData] = useState({ show: false });
  const [filterValue, setFilterValue] = useState("");
  const [experience, setExperience] = useState({ stats: {}, data: [] })
  const [pagination, setPagination] = useState(1);

  const page = history?.location?.pathname.split('/').pop();


  const [iconData, setIconData] = useState([
    {
      count: 0,
      link: `/experienceDashboard/pending`,
      icon: pendingNew,
      code: 'pending',
      name: 'Pending',
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/all`,
      icon: AllIcon,
      code: 'all',
      name: 'All',
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/special`,
      icon: seatingNew,
      code: 'special',
      name: "Occasions",
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/curated`,
      icon: historyNew,
      code: 'curated',
      name: "Events",
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/history`,
      icon: histNew,
      code: 'history',
      name: "History",
      showNotification: false
    }
  ]);


  useEffect(() => {
    async function fetchData() {
      let response = await amApi.get(`/expRequest?status=all_special`);
      let stats = await amApi.get(`/expRequest?status=pending&type=STATS_BY_TYPE`);
      let icnData = [...iconData];
      icnData[0].count = stats?.data?.[0]?.pendingCount || 0;
      icnData[1].count = stats?.data?.[0]?.allCount || 0;
      icnData[2].count = stats?.data?.[0]?.specialCount || 0;
      icnData[3].count = stats?.data?.[0]?.curatedCount || 0;
      setIconData(icnData);
      setExpRequests(response.data.reverse());

    }
    if (page) {
      fetchData()
    }
  }, [page])

  useEffect(() => {
    async function fetchData() {
      let stats = await amApi(`/experience?vendorStats=true&type=CURATED&requestType=ACTIVE`);
      let expData = await amApi(`/experience?requestType=ACTIVE&vendor=true&type=CURATED&page=1&limit=20`);
      let statsCount = await amApi.get(`/experience?type=expCount`);
      let icnData = [...iconData];
      icnData[0].count = statsCount?.data?.[0]?.specialCount || 0;
      icnData[1].count = statsCount?.data?.[0]?.curatedCount || 0;
      setIconData(icnData);
      setExperience({ stats: stats.data[0], data: expData.data });
    }
    fetchData()
  }, [])


  const handlePagination = async (pageNo) => {
    let response = await amApi.get(`/experience?requestType=ACTIVE&vendor=true&type=CURATED&page=${pageNo || 1}&limit=20`);
    setExperience({ ...experience, data: response.data });
    setPagination(pageNo);
  }

  const removeExp = (id, active) => {
    let exp = experience.data.filter(ele => ele._id !== id);
    setExperience({ stats: { activeCount: experience.stats.activeCount - (active ? 1 : 0), inActiveCount: experience.stats.inActiveCount - (!active ? 1 : 0) }, data: exp })
  }

  const updatePrimary = (id, type) => {
    let notPrimary = [...experience.data];
    if (type === "ACTIVE") {
      notPrimary = experience.data.map(ele => { return { ...ele, active: ele._id === id ? !ele.active : ele.active } });
    } else if (type === 'PRIMARY') {
      notPrimary = experience.data.map(ele => { return { ...ele, primary: ele._id === id ? !ele.primary : false } });
    }
    setExperience({ stats: experience.stats, data: notPrimary })
  }

  let filteredData = experience?.data;
  if (search) {
    let searchData = new RegExp(search, "i");
    filteredData = experience?.data.filter((getall) => {
      if (searchData.test(getall?.name) || searchData.test(getall?.expId) || searchData.test(getall?.category?.title) || searchData.test(getall?.subCategory?.title)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  filteredData = filteredData?.filter((getall) => {
    if (filterValue === "All" || filterValue === "") {
      return true;
    } else {
      return getall.active === filterValue;
    }
  });



  return (
    <React.Fragment>
      {/* <Media query="(min-width: 992px)"> */}
        <div className="container-fluid seating_dashboard_top_new_header">
          <div className="mt-3 d-flex justify-content-between align-items-center">
            <div className="col-6">
              <ExpDashboardIcons data={iconData} page={page} exp={null} history={history} />
            </div>
            <div>
              <span className="p-2 px-3 f12-500" style={{ minWidth: '60px', color: "white", borderRadius: '30px', backgroundColor: "rgb(248, 80, 50)", cursor: 'pointer' }} onClick={() => history.push('/specialDashboard')}>
                Manage Experiences
              </span>
            </div>
          </div>
          <Row>
            <Col md={5} className="d-flex align-items-center">
              <SearchBar onChange={setSearch} />
            </Col>
            <Col md={3}>
              <div className="d-flex align-items-center justify-content-end">
                < StatusFilter
                  statusfilter={true}
                  values={(e) => { setFilterValue(e) }} />
                <div className="f10-400" align="center">
                  <img
                    src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                    width="48px"
                  />
                </div>
              </div>
            </Col>
            <Col md={3} className="d-flex align-items-center">
              <RightSideCountTop
                content={[
                  {
                    name: "Inactive Experiences",
                    value: experience?.stats?.inActiveCount || 0
                    ,
                    backgroundColor: "#EFEBFB",
                    color: "#6F32C9",
                  },
                  {
                    name: "Active Experiences",
                    value: experience?.stats?.activeCount || 0,
                    backgroundColor: "#D8F3F4",
                    color: "#138B90",
                  },
                ]}
              />
            </Col>
          </Row>
          {/* <Media query="(min-width: 992px)"> */}
          <div className="row mt-2">
            <div className=" col-12 p-0 user-table-reusable-superadmin table-responsive">
              <Table>
                <thead style={{ position: 'sticky', top: '2px' }}>
                  <tr className="super_admin_all_users_table_head">
                    <td style={{ width: "2%" }} className="f12-400">
                    </td>
                    <td style={{ width: "20%" }} className="f12-400">
                      My Experience/
                      <br /> Experience ID
                    </td>
                    <td style={{ width: "20%" }} className="f12-400">
                      Start Date
                      <br />
                      End date
                    </td>
                    <td style={{ width: "15%" }} className="f12-400">
                      Pricing
                    </td>
                    <td style={{ width: "15%" }} className="f12-400">
                      User | Left
                      <br /> Count
                    </td>
                    <td style={{ width: "15%" }} className="f12-400">
                      Venue
                    </td>
                    <td style={{ width: "20%" }} className="f12-400 text-center">
                      Actions
                    </td>
                    <td style={{ width: "20%" }} className="f12-400 text-center">
                      More Actions
                    </td>
                  </tr>
                </thead>
                {!filteredData ? <SmallLoader />
                  : filteredData?.length === 0 ? <NoContent />
                    : filteredData.map(exp => <ExperienceBody exp={exp} removeExp={removeExp} updatePrimary={updatePrimary} disable={true}/>
                    )}
              </Table>
            </div>
            </div>
          {/* </Media> */}
        </div>
      {/* </Media> */}
      <div style={{ position: 'relative' }}>
        {!!filteredData?.length && <BasicPagination
          totalRecords={filteredData?.length || 0}
          limit={20}
          batch={pagination}
          onBatchChange={(e) => handlePagination(e)}
        />
        }
        <div style={{ position: 'absolute', right: '36px', top: '26px', color: '#2196F3', textDecoration: "underline" }} className="f12-400" onClick={() => {
          history.push('/expiredexperiencesDashboard', { exptype: 'curated' })
        }}>
          View Expired Experience
        </div>
      </div>
    </React.Fragment >
  );
};

export default ExperienceCuratedDashboard;
